import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.ROOT_API, //http://vvg.chat.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});

export const HTTPVELOCITY = axios.create({

  baseURL: "https://www.velocitytruckcenters.com", //http://vvg.salesintranet.com/api/v1
  headers: {
    'Content-Type': 'application/json',
  }
});


// WEBPACK FOOTER //
// ./src/http-common.js